import microuniversoApi from "app/api/microuniversoApi"
import { atualizarClienteAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { ICliente } from "app/types/ICliente"
import { atualizarOrcamento } from "../atualizarOrcamento"
import { IOrcamento } from 'app/types/IOrcamento';

declare var window: any;
const Backbone = require('backbone')

export async function atualizarClienteOrcamento (cliente: ICliente, senha?: string, senhaVendedorRelacionado?: string, senhaClienteComLimiteCreditoBloqueado?: string, validarCliente?: boolean) {
  const resposta = await microuniversoApi.Orcamento.atualizarCliente(store.getState().orcamento.IdentificadorOrcamento, cliente?.Codigo, senha, senhaVendedorRelacionado, senhaClienteComLimiteCreditoBloqueado, validarCliente)

  if (!("HasErrors" in resposta) || resposta.HasErrors == false) {
    await atualizarOrcamento()
    store.dispatch(sobrescreverInformacoesAction({
      CodigoFormaPagamento: (resposta as IOrcamento).CodigoFormaPagamento,
      CodigoTipoDocumento: (resposta as IOrcamento).CodigoTipoDocumento,
    }))
    store.dispatch(atualizarClienteAction({
      Cliente: cliente,
      CodigoCliente: cliente.Codigo,
      NomeCliente: cliente.Nome
    }))
    // window.orcamentoController.model.set("Cliente", new Backbone.Model(cliente))
    // window.orcamentoController.model.set("CodigoCliente", cliente.Codigo)
    // window.orcamentoController.mostrarNomeCliente()
  }
  
  return resposta
}
